module.exports = __webpack_public_path__ + "static/media/landing-page-ptplus.e2350086.webp";